'use client';

import { useState } from 'react';
import styles from './ProjectedORWidget.module.css';
import { useSamarthDashboardContext } from 'utils/samarth-dashboard-context/hooks/useSamarthDashboardContext';
import WidgetWrapper from '../widget-wrapper/widget-wrapper';
import ChartSkeleton from '../../ui/chart-skeleton/chart-skeleton';
import AreaGraphCharts from '../../ui/areaChart/AreaChart';
import ProjectedORChart from '../../ui/ProjectedOrCharts/ProjectedOrChart';
import ProjectOrActionTable from '../../ui/tables/projectedOr/ProjectOrActionTable';
import ProjectedORTable from '../../ui/tables/projectedOr/ProjectedOrTable';
import WeeklyOr from './weeklyOr';


export default function ProjectedORWidget() {
  const [isOn, setIsOn] = useState(false);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [weekly, setWeekly] = useState(false);

  const { state } = useSamarthDashboardContext();

  const globalViewMode =  state.viewMode.globalViewMode;
  const actionFilter = state.filters.actionFilter;
  const loaderProj = state.dashboardData.isLoading.projectedOR;
  const chartData = state.dashboardData.projectedOR;
  const ProjectedORTableData = state.dashboardData.projectedOrTable;

  const handlePopup = () => setIsPopupOpen(!isPopupOpen);

  return (
    <WidgetWrapper
      title={weekly ? 'Weekly OR' : 'Projected OR'}
      isTableView={globalViewMode === 'table'}
      showBlueDot={globalViewMode === 'table'}
      isOn={isOn}
      setIsOn={setIsOn}
      toogleLables={['%', 'Abs']}
      isDialogOpen={isPopupOpen}
      setIsDialogOpen={handlePopup}
      infoText={
        weekly
          ? 'Weekly OR indicates how well actual production meets the Weekly production plan.'
          : 'Projected OR indicates how well actual production meets the daily production plan.'
      }
    >
      <div className={`${styles.contentWrapper} ${globalViewMode === 'table' ? styles.tablePadding : ''} border-box`}>
        {weekly ? (
          <WeeklyOr isOn={isPopupOpen} isSWitchOn={isOn} />
        ) : (
          <>
            {loaderProj ? (
              <ChartSkeleton isOn={isPopupOpen} />
            ) : globalViewMode === 'graph' ? (
              !actionFilter ? (
                <ProjectedORChart data={chartData} />
              ) : (
                <AreaGraphCharts
                  data={chartData}
                  valueKey={'value'}
                  dataKey={'day'}
                  gradients={[['#4DA1FF', '#050F318F'], ['#CF98D9', '#050F318F']]}
                  customDots
                  graphsNames={['projected', 'plan']}
                  activeDots={['#4DA1FF', '#CF98D9']}
                  minWidthNeeded
                  showPercentage={false}
                  MyTooltipComponent={(props) => (
                    <div>
                      <div className={styles.tooltipRow}><span className={styles.dotBlue} />Plan : {props.payload?.plan}</div>
                      <div className={styles.tooltipRow}><span className={styles.dotPink} />Projected : {props.payload?.projected}</div>
                    </div>
                  )}
                />
              )
            ) : actionFilter ? (
              <ProjectOrActionTable data={ProjectedORTableData} isOn={!isOn} />
            ) : (
              <ProjectedORTable data={!isOn ? ProjectedORTableData : chartData} isOn={!isOn} />
            )}
          </>
        )}
      </div>
        <div
          className={styles.toggleWeeklyBtn}
          onClick={() => setWeekly(!weekly)}
        >
          {!weekly ? 'Weekly' : 'Projected'} OR <img src="/assets/arrowUpDown.svg" alt="" style={{ color : "white" , height:12}} />
        </div>
    </WidgetWrapper>
  );
}
